import { Link } from 'react-router-dom'
import { Terminal, Github, Twitter } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  const sections = [
    {
      title: 'Product',
      links: [
        { to: '/browse', label: 'Browse Skills' },
        { to: '/docs', label: 'Documentation' },
        { to: '/docs/cli', label: 'CLI Reference' },
        { to: '/docs/api', label: 'API Reference' },
      ],
    },
    {
      title: 'Publishers',
      links: [
        { to: '/docs/publishing', label: 'Publishing Guide' },
        { to: '/docs/manifest', label: 'Manifest Schema' },
        { to: '/docs/review', label: 'Review Process' },
        { to: '/docs/pricing', label: 'Pricing' },
      ],
    },
    {
      title: 'Company',
      links: [
        { to: '/about', label: 'About' },
        { to: '/blog', label: 'Blog' },
        { to: '/careers', label: 'Careers' },
        { to: '/contact', label: 'Contact' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { to: '/privacy', label: 'Privacy Policy' },
        { to: '/terms', label: 'Terms of Service' },
        { to: '/security', label: 'Security' },
      ],
    },
  ]

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center">
                <Terminal className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-white">Xarlie</span>
            </Link>
            <p className="mt-4 text-sm text-gray-400">
              The App Store for MCP Skills. Discover, install, and manage Model Context Protocol integrations.
            </p>
            <div className="mt-4 flex space-x-4">
              <a
                href="https://github.com/xarlie-io"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="GitHub"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com/xarlie_io"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          {sections.map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-semibold text-white uppercase tracking-wider">
                {section.title}
              </h3>
              <ul className="mt-4 space-y-2">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              {currentYear} Xarlie. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <Link to="/status" className="hover:text-white transition-colors">
                Status
              </Link>
              <a
                href="mailto:support@xarlie.io"
                className="hover:text-white transition-colors"
              >
                Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
